document.querySelectorAll('.owl-toggle-header').forEach(function(item) {
    item.addEventListener('click', function(e) {
        e.preventDefault();
        let obj = this;
        let icon = obj.querySelector('.owl-toggle-icon');
        let content = obj.nextElementSibling;
        var faq;
        if (obj.classList.contains('owl-faq-header')) {
            faq = obj.parentNode.parentNode;
        }

        if (obj.classList.contains('active')) {
            if (obj.classList.contains('owl-faq-header')) {
                faq.classList.remove('active');
            }
            obj.classList.remove('active');
            icon.classList.remove('active');
            slideUp(content);
        } else {
            if (obj.classList.contains('owl-faq-header')) {
                faq.classList.add('active');
            }
            obj.classList.add('active');
            icon.classList.add('active');
            slideDown(content);
        }
    });
});

function slideUp(element) {
    element.style.maxHeight = '0';
}

function slideDown(element) {
    element.style.maxHeight = element.scrollHeight + 'px';
}

